/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Project = {

	deleteAgreementAttachment (context, projectId, fileToReplaceHash, onSuccess, onError, options) {
		Api.delete(context,
			"/project/agreement-attachment"
			+ "?projectId=" + projectId
			+ "&fileToReplaceHash=" + fileToReplaceHash
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteCorrespondence (context, projectId, fileHash, onSuccess, onError, options) {
		Api.delete(context,
			"/project/correspondence"
			+ "?projectId=" + projectId
			+ "&fileHash=" + fileHash
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteDonationContract (context, projectId, fileHash, onSuccess, onError, options) {
		Api.delete(context,
			"/project/donation-contract"
			+ "?projectId=" + projectId
			+ "&fileHash=" + fileHash
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteLastVersion (context, projectId, onSuccess, onError, options) {
		Api.delete(context,
			"/project/last-version"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteSignedReportFile (context, projectId, onSuccess, onError, options) {
		Api.delete(context,
			"/project/signed-report-file"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgreement (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/agreement"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgreementAndAttachmentsList (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/agreement-and-attachments-list"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllBidderNames (context, onlyMine, onSuccess, onError, options) {
		Api.get(context,
			"/project/all-bidder-names"
			+ "?onlyMine=" + onlyMine
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllBidderNamesByAgency (context, onSuccess, onError, options) {
		Api.get(context,
			"/project/all-bidder-names-by-agency"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllContestNames (context, onlyMine, onSuccess, onError, options) {
		Api.get(context,
			"/project/all-contest-names"
			+ "?onlyMine=" + onlyMine
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllContestNamesByAgency (context, onSuccess, onError, options) {
		Api.get(context,
			"/project/all-contest-names-by-agency"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllProjectsNamesAndCodes (context, onSuccess, onError, options) {
		Api.get(context,
			"/project/all-projects-names-and-codes"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllowedBasicData (context, onSuccess, onError, options) {
		Api.get(context,
			"/project/allowed-basic-data"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAmountRemarks (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/amount-remarks"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAmounts (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/amounts"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAnnexFiles (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/annex-files"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getArrears (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/arrears"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAvailableProjectMutualBidders (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/available-project-mutual-bidders"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/basic-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataByCode (context, code, onSuccess, onError, options) {
		Api.get(context,
			"/project/basic-data-by-code"
			+ "?code=" + code
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataList (context, ids, onSuccess, onError, options) {
		Api.get(context,
			"/project/basic-data-list"
			+ "?ids=" + ids
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderAndMutualNames (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/bidder-and-mutual-names"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderFundings (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/bidder-fundings"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getComparison (context, projectId, firstVersion, secondVersion, onSuccess, onError, options) {
		Api.get(context,
			"/project/comparison"
			+ "?projectId=" + projectId
			+ "&firstVersion=" + firstVersion
			+ "&secondVersion=" + secondVersion
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/configuration"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCorrectionHistory (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/correction-history"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCorrespondence (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/correspondence"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataVersion (context, projectId, version, onSuccess, onError, options) {
		Api.get(context,
			"/project/data-version"
			+ "?projectId=" + projectId
			+ "&version=" + version
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDocument (context, fileId, onSuccess, onError, options) {
		Api.get(context,
			"/project/document"
			+ "?fileId=" + fileId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDonationContract (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/donation-contract"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalReportRemarks (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/final-report-remarks"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getLastVersionComparison (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/last-version-comparison"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getMainBidderEmail (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/main-bidder-email"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPanelPermissionsForUser (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/panel-permissions-for-user"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectFile (context, hash, onSuccess, onError, options) {
		Api.get(context,
			"/project/project-file"
			+ "?hash=" + hash
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectPrioritiesSummary (context, projectId, version, onSuccess, onError, options) {
		Api.get(context,
			"/project/project-priorities-summary"
			+ "?projectId=" + projectId
			+ "&version=" + version
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectsByAgencyCountry (context, onSuccess, onError, options) {
		Api.get(context,
			"/project/projects-by-agency-country"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectsWithoutReports (context, onSuccess, onError, options) {
		Api.get(context,
			"/project/projects-without-reports"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPublicBasicData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/public-basic-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getReadonly (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/readonly"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getRequestedDotation (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/requested-dotation"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSignedReportFile (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/signed-report-file"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getStatus (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/status"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSummaryMainData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/summary-main-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSummaryTasksData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/summary-tasks-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSummaryUsersData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/summary-users-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTerms (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project/terms"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getVolunteerProjects (context, volunteerId, onSuccess, onError, options) {
		Api.get(context,
			"/project/volunteer-projects"
			+ "?volunteerId=" + volunteerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/project"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAgreement (context, agreementFile, attachments, signDate, number, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/project/agreement"
			+ "?agreementFile=" + agreementFile
			+ "&attachments=" + attachments
			+ "&signDate=" + signDate
			+ "&number=" + number
			+ "&projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAgreementFile (context, projectId, fileToUpload, onSuccess, onError, options) {
		Api.post(context,
			"/project/agreement-file"
			+ "?projectId=" + projectId
			+ "&fileToUpload=" + fileToUpload
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCorrespondence (context, projectId, donationContracts, onSuccess, onError, options) {
		Api.post(context,
			"/project/correspondence"
			+ "?projectId=" + projectId
			+ "&donationContracts=" + donationContracts
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postDonationContract (context, projectId, donationContracts, onSuccess, onError, options) {
		Api.post(context,
			"/project/donation-contract"
			+ "?projectId=" + projectId
			+ "&donationContracts=" + donationContracts
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postGivePrivillages (context, projectId, userId, onSuccess, onError, options) {
		Api.post(context,
			"/project/give-privillages"
			+ "?projectId=" + projectId
			+ "&userId=" + userId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postProjectSupervisor (context, projectId, supervisorId, onSuccess, onError, options) {
		Api.post(context,
			"/project/project-supervisor"
			+ "?projectId=" + projectId
			+ "&supervisorId=" + supervisorId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSignedReportFile (context, projectId, fileToUpload, onSuccess, onError, options) {
		Api.post(context,
			"/project/signed-report-file"
			+ "?projectId=" + projectId
			+ "&fileToUpload=" + fileToUpload
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, projectId, projectDto, onSuccess, onError, options) {
		Api.put(context,
			"/project"
			+ "?projectId=" + projectId
			, projectDto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAccept (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/accept"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAgreement (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/agreement"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAmountRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/amount-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putApprove (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/approve"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putArchive (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/archive"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putArrears (context, projectArrearsDataDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/arrears"
			, projectArrearsDataDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrespondenceRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/correspondence-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, projectId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/project/data"
			+ "?projectId=" + projectId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDonationContractRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/donation-contract-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinalReportRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/final-report-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/finish"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putForm (context, projectId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/project/form"
			+ "?projectId=" + projectId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putHide (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/hide"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putLoadActionsDescritopns (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/load-actions-descritopns"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putMonitoringRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/monitoring-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putReject (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/reject"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putReplaceAgreementFile (context, projectId, fileToUpload, fileToReplaceHash, onSuccess, onError, options) {
		Api.put(context,
			"/project/replace-agreement-file"
			+ "?projectId=" + projectId
			+ "&fileToUpload=" + fileToUpload
			+ "&fileToReplaceHash=" + fileToReplaceHash
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRequestChanges (context, projectId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/project/request-changes"
			+ "?projectId=" + projectId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSendForAcceptance (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/send-for-acceptance"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSubmit (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/submit"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSummaryDonation (context, projectId, donationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/summary-donation"
			+ "?projectId=" + projectId
			, donationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putTerms (context, projectId, termsDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/terms"
			+ "?projectId=" + projectId
			, termsDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoApproval (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/undo-approval"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoArchive (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/undo-archive"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoFinish (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/undo-finish"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoHide (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/undo-hide"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoRequestChanges (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/undo-request-changes"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoWithdrawal (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/project/undo-withdrawal"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putVolunteerRemarks (context, projectId, remarksDTO, onSuccess, onError, options) {
		Api.put(context,
			"/project/volunteer-remarks"
			+ "?projectId=" + projectId
			, remarksDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putWithdraw (context, projectId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/project/withdraw"
			+ "?projectId=" + projectId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
